import React, { useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  notesSliceSelector,
  UpdateNotification,
} from "../../../features/notes/notesSlice";
import { useDispatch, useSelector } from "react-redux";
import Notifications from "./Notifications";

const NoteNotification = ({ userId, t }) => {
  const dispatch = useDispatch();
  const { notifications } = useSelector(notesSliceSelector);

  const removeNote = (
    fileID,
    notificationID,
    notificationText,
    addedBy,
    readBy
  ) => {
    dispatch(
      UpdateNotification(
        fileID,
        notificationID,
        notificationText,
        addedBy,
        readBy,
        userId
      )
    );
  };

  return (
    <div
      style={{
        width: 348,
        right: -35,
        paddingRight: 0,
      }}
      className="absolute bg-white p-4 rounded-lg shadow-lg w-full max-w-md w-[348px]"
    >
      <h2 className="text-xl font-bold text-gray-800 border-b pb-4">
        {t("noteNotification")}
      </h2>
      <div
        className="space-y-4 mt-4"
        style={{ overflowY: "auto", maxHeight: "350px" }}
      >
        {notifications.length > 0 ? (
          notifications.map((note, index) => (
            <Notifications
              fileNumber={note.fileNumber}
              fileID={note.fileID}
              notificationID={note.notificationID}
              notificationText={note.notificationText}
              addedBy={note.addedBy}
              userId={userId}
              dateAdded={note.dateAdded}
              removeNote={removeNote}
              index={index}
              t={t}
            />
          ))
        ) : (
          <div className="flex justify-center items-center my-10">
            {" "}
            <p className="text-center text-gray-500 font-bold">
              {t("NoResults")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NoteNotification;
